import axios from 'axios';

import {envConfig} from 'config';
import {InviteeToken} from 'services/InviteeToken';

import {API_URL} from './constants';

const getPublicTwilioVideoToken = async (): Promise<{token: string}> => {
    const res = await axios.get(`${API_URL}/twilio/video-token`);
    return res.data;
};

const getClientTwilioVideoToken = async (): Promise<{token: string}> => {
    const res = await axios.get(`${API_URL}/twilio/video-token/client`, {
        headers: {Authorization: `Bearer ${InviteeToken.get()}`}
    });
    return res.data;
};

const getAgentTwilioVideoToken = async (params: any): Promise<{token: string}> => {
    const res = await axios.get(`${API_URL}/twilio/video-token/agent`, {params});
    return res.data;
};

const getAgentTwilioVoiceToken = async (): Promise<{token: string}> => {
    const res = await axios.get(`${API_URL}/twilio/voice-token/agent`);
    return res.data;
};

const getClientTwilioVoiceToken = async (): Promise<{token: string}> => {
    const res = await axios.get(`${API_URL}/twilio/voice-token/client`, {
        headers: {Authorization: `Bearer ${InviteeToken.get()}`}
    });
    return res.data;
};

const getPublicInternalWebRTCToken = async (roomName: string): Promise<{token: string}> => {
    const res = await axios.post(`${envConfig.webrtcServerApiUrl}/webrtc-server/token`, {roomName});
    return res.data;
};

const getClientInternalWebRTCToken = async (): Promise<{token: string}> => {
    const res = await axios.get(`${envConfig.webrtcServerApiUrl}/webrtc-server/token/client`, {
        headers: {Authorization: `Bearer ${InviteeToken.get()}`}
    });
    return res.data;
};

const getAgentInternalWebRTCToken = async (params: any): Promise<{token: string}> => {
    const res = await axios.get(`${envConfig.webrtcServerApiUrl}/webrtc-server/token/agent`, {params});
    return res.data;
};

export const videoTokenApi = {
    getPublicTwilioVideoToken, getClientTwilioVideoToken, getAgentTwilioVideoToken, getAgentTwilioVoiceToken,
    getPublicInternalWebRTCToken, getClientInternalWebRTCToken, getAgentInternalWebRTCToken, getClientTwilioVoiceToken
};
